export const baseUrl =
  process.env.NODE_ENV === "development"
    ?  "https://winnovation.org/winn_admin/api"
    : "https://winnovation.org/winn_admin/api";
    